import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';
import TaxLotsPage from '../../../../../components/tax-lots/TaxLotsPage';
import { isModuleEnabled } from '../../../../../data/app-config/configs/configUtilities';
import { taxLotsSearchSchema } from '../../../../../routes/-taxLotsParamsSchema';

function ClientAppTaxLots() {
  const transactionsEnabled = isModuleEnabled({ moduleName: 'transactions' });

  if (transactionsEnabled) {
    return <TaxLotsPage />;
  }

  return null;
}

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/tax-lots',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ClientAppTaxLots,
  validateSearch: (search) => {
    const parsed = taxLotsSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
  staticData: {
    configPageId: 'tax-lots',
    isClientRoute: true,
    meta: {
      title: 'Client Tax Lots | Ledgible',
    },
  },
});
